import { MenuNode, MenuNodeMeta } from '.'
import { envConfig } from '@/plugins/env'
import user from '@/store/user'


export const Menus: MenuNode[] = [
  new MenuNode({
    id: 1,
    name: 'home',
    meta: new MenuNodeMeta({ icon: 'o_home', title: '首頁' }),
  }),
  /* TODO: CYBSS-480 CYBSS-482
  new MenuNode({
    id: 2,
    name: 'member_profile',
    meta: new MenuNodeMeta({ icon: 'person', title: '我的帳戶' }),
  }),*/
  new MenuNode({
    id: 3,
    name: 'subscription_management',
    meta: new MenuNodeMeta({ icon: 'credit_card', title: '我的訂閱' }),
  }),
  new MenuNode({
    id: 4,
    name: 'gup_statistics',
    meta: new MenuNodeMeta({
      icon: 'sym_o_monitoring', title: '數據後台',
      clickEvent: () => { window.open(`${envConfig.GUP_DATA_BACKEND_WEB_URL}?auth_token=${user.state.tokens.accessToken}`, '_blank') }
    }),
  }),
  new MenuNode({
    id: 5,
    name: 'report_download',
    meta: new MenuNodeMeta({
      icon: 'sym_o_monitoring', title: '報表下載', hidden: true
    }),
  }),
  new MenuNode({
    id: 900,
    name: 'helpdesk',
    meta: new MenuNodeMeta({ icon: 'help', title: '服務中心' }),
  }),
]
